import { PrefetchContext } from '$templates/pages/utils/prefetch-data';
import { createFrameQueryOptionsForServer } from '../hooks/use-frame';

export async function framePrefetch({ serverContext, httpHeaders, queryClient }: PrefetchContext) {
    const queryOptions = createFrameQueryOptionsForServer(serverContext.resolvedUrl, httpHeaders);
    await queryClient.prefetchQuery(...queryOptions);
}
